export default __webpack_public_path__ + "static/flag-ie-bd4efef1b631975a1d3eba34159ffd3a.svg";